"use client";

import React from "react";
import Image from "next/image";

interface BannerImageData {
  attributes?: {
    url?: string;
  };
}

interface BannerImage {
  data?: BannerImageData;
}

interface BannerBlock {
  title?: string;
  form_title?: string;
  banner_image?: BannerImage;
}

interface BannerProps {
  block?: BannerBlock;
}

const Banner: React.FC<BannerProps> = () => {
  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[240px] pb-[56px] xl:pb-[160px] lg:pb-[80px] relative z-0">
          {/* Shapes */}
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          <div className="absolute bottom-0 right-0 z-[2] w-[160px] md:w-[260px] opacity-10">
            <Image
              src="/images/ThankYouBanner.png"
              alt="Banner Image"
              width={260}
              height={260}
              className="w-full h-full"
            />
          </div>
          <div className="absolute bottom-0 left-0 z-[2] w-[160px] md:w-[260px] opacity-10">
            <Image
              src="/images/ThankYouBanner-left.png"
              alt="Banner Image"
              width={260}
              height={260}
              className="w-full h-full"
            />
          </div>

          {/* Content */}
          <div className="container">
            <div className="blog-heading">
              <h1 className="text-center text-white font-[800] text-display uppercase">
                Thank you!
              </h1>
              <p className="text-primary-text-white text-center font-bold text-heading-3 mt-[32px]">
                Thank you for Connecting with TRooTech.
              </p>
              <p className="max-w-[848px] mx-auto text-secondary-text-white text-center font-regular text-subtitle-2 mt-[12px]">
                We appreciate your interest and invite you to explore our
                enterprise insights as we prepare to connect with you shortly
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
